module.exports = __webpack_public_path__ + "static/media/pin.ed27c9b1.svg";